import { FunctionComponent } from "react"
import { RadioChangeEvent } from "antd"
import { RadioGroup } from "src/global/ui/Radio/RadioGroup"
import { DqiValue, DqiFilterOption, DQI_OPTIONS } from "src/pages/DataHealthDashboard/constants"

export type { DqiValue, DqiFilterOption }
export { DQI_OPTIONS }

export interface DqiFilterProps {
  value: DqiValue
  onChange: (value: DqiValue) => void
}

export const DqiFilter: FunctionComponent<DqiFilterProps> = ({ value, onChange }) => {
  const handleChange = (e: RadioChangeEvent) => {
    onChange(e.target.value as DqiValue)
  }

  return (
    <RadioGroup optionType="button" buttonStyle="solid" value={value} onChange={handleChange} options={DQI_OPTIONS} />
  )
}
